import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class BannerComponent {
    constructor() {
        BannerComponent.init()
    }

    static async init() {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
        const videoContainer = '[data-banner-video]'
        const swiperContainer = '[data-banner-slider]'

        // Show banner video only on desktop
        if ($(videoContainer).length > 0 && window.matchMedia('(min-width: 1001px)').matches) {
            const videoElmt = document.createElement('video')
            const videoSrc = document.createElement('source')

            // config
            videoSrc.type = $(videoContainer).data('banner-video-type')
            videoSrc.src = $(videoContainer).data('banner-video-src')
            videoElmt.muted = true
            videoElmt.loop = true

            videoElmt.appendChild(videoSrc)
            $(videoContainer).append(videoElmt)
            videoElmt.play()

            // Hide banner heading
            setTimeout(() => {
                const header = document.querySelector('.header')
                header.classList.add('hide-text')

                let timeout
                header.addEventListener('mousemove', () => {
                    header.classList.remove('hide-text')

                    clearTimeout(timeout)
                    timeout = setTimeout(() => {
                        header.classList.add('hide-text')
                    }, 3000)
                })
            }, 3000)
        } else if ($(swiperContainer).length > 0) {
            const options = {
                slidesPerView: 'auto',
                autoplay: {
                    delay: 6000,
                },
                speed: 1500,
                pagination: {
                    el: '#swiper-banner-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                navigation: {
                    nextEl: '#swiper-banner-next',
                    prevEl: '#swiper-banner-prev',
                },
                mousewheel: {
                    forceToAxis: true,
                },
                grabCursor: true,
                loop: true,
                spaceBetween: 30,
                maxBackfaceHiddenSlides: isSafari ? 10 : 0,
            }

            // insert navigation / pagination
            $(`${swiperContainer}> *`)
                .wrapAll('<div class="swiper-wrapper"></div>')
                .addClass('swiper-slide')

            await Swiper.create(swiperContainer, options)
        }
    }
}
